import NextMeetingCard from './NextMeetingCard';
export default NextMeetingCard;